import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      fontSize={size}
      style={style}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M15.0364 0.978783C15.5784 1.52865 15.9154 2.19235 15.9854 2.84792C16.0654 3.58887 15.8194 4.2729 15.2734 4.82785L15.0424 5.06162C15.0404 5.06365 15.0404 5.06568 15.0384 5.06772L13.5464 6.58315C13.5454 6.58417 13.5444 6.58417 13.5444 6.58519C13.5438 6.58519 13.5435 6.58557 13.5432 6.58611C13.543 6.58644 13.5428 6.58683 13.5424 6.58722L5.12037 14.944C5.04937 15.0141 4.96237 15.0588 4.87237 15.0781L0.879372 15.9837C0.826372 15.9949 0.773372 16 0.720372 16C0.527372 16 0.342372 15.9217 0.204372 15.7774C0.0293722 15.5945 -0.0386278 15.3373 0.0213722 15.0893L1.00737 11.0542C1.02737 10.9628 1.07437 10.8764 1.14437 10.8063L1.14637 10.8042L9.56637 2.4495L11.0104 0.981832C11.0109 0.981324 11.0111 0.980816 11.0114 0.980307C11.0116 0.979799 11.0119 0.979291 11.0124 0.978783L11.2494 0.737899C11.7224 0.255114 12.3064 0 12.9344 0H12.9364C13.6694 0 14.4154 0.347605 15.0364 0.978783ZM12.9354 1.01639H12.9364C13.4024 1.01639 13.8964 1.25727 14.3294 1.69737C14.7114 2.08461 14.9454 2.53183 14.9914 2.95871C15.0324 3.33477 14.9194 3.67526 14.6734 3.97815L12.0934 1.3579C12.3494 1.14649 12.6284 1.01639 12.9354 1.01639ZM13.1974 5.50172L10.6194 2.81641L11.3674 2.05616L13.9774 4.70893L13.1974 5.50172ZM4.77937 13.8625L2.20137 11.1782L9.90737 3.53195L12.4854 6.21522L4.77937 13.8625ZM1.76337 12.1763L1.10037 14.8911L3.78637 14.2833L1.76337 12.1763Z" />
    </svg>
  );
}